/**
 * Tiny module for the "Auto-play next episode" preference.
 *
 * When enabled (the default), tapping an episode pre-loads the rest of the
 * season into the native player so it advances automatically when the
 * current file ends. When disabled the native player exits back to the
 * episode list as soon as one episode finishes — useful if you want to
 * pick the next thing manually.
 */
const KEY = "zapp_autoplay_next_episode";

export function isAutoPlayNextEpisodeEnabled() {
  try {
    const v = localStorage.getItem(KEY);
    if (v === null) return true; // default ON
    return v === "1" || v === "true";
  } catch {
    return true;
  }
}

export function setAutoPlayNextEpisodeEnabled(enabled) {
  try {
    localStorage.setItem(KEY, enabled ? "1" : "0");
  } catch {
    /* no-op */
  }
}
